/**
 * NOTIFICATIONS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getNotifications,
    getNotification,
    printNotification,
    createNotifications,
    updateNotifications,
    deleteNotifications,
    sendEmail,
    readOrUnreadNotifications,
    getMeNotifications,
} from "Core/configuration/notifications/config/api.notifications";

const state = {
    notifications_page: {},
    form: {},
    notifications: [],
    inAppNotifications: [],
    selectedNotification: {
        notification_id: null,
        company_id: "",
        notification_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        notification_details: [],
    },
    notifications_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        people_id: "",
        status: "",
    },
    rules_notifications: {
        notification_id: {
            name: "notification_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        subject: {
            name: "subject",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        message: {
            name: "message",
            rules: "trim|required",
            max_len: "16777215",
            min_len: "",
            default_value: "",
        },
        object_name: {
            name: "object_name",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        object_id: {
            name: "object_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        modal: {
            name: "modal",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        file: {
            name: "file",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        icon: {
            name: "icon",
            rules: "trim|max_length[45]",
            max_len: "45",
            min_len: "",
            default_value: "",
        },
        icon_class: {
            name: "icon_class",
            rules: "trim|max_length[15]",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        read_flag: {
            name: "read_flag",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
    },
    rules_email_info: {
        to: {
            name: "to",
            rules: "required",
            default_value: [],
        },
        cc: {
            name: "cc",
            rules: "",
            default_value: [],
        },
        bcc: {
            name: "bcc",
            rules: "",
            default_value: [],
        },
        subject: {
            name: "subject",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        message: {
            name: "message",
            rules: "trim",
            max_len: "65000",
            min_len: "",
            default_value: "",
        },
        files: {
            name: "files",
            rules: "",
        },
    },
};

// getters
const getters = {
    notifications: (state) => {
        return state.notifications;
    },
    inAppNotifications: (state) => {
        return state.inAppNotifications;
    },
};

// actions
const actions = {
    async fetchNotifications({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getNotifications({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageNotifications", response.data.page);
                }

                commit("setNotifications", response.data.notifications);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchMeNotifications({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getMeNotifications({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageNotifications", response.data.page);
                } else {
                    commit("setPageNotifications", {});
                }

                commit("setNotifications", response.data.notifications);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchNotification({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getNotification(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedNotification", response.data.notification);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async fetchInAppNotifications({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getMeNotifications({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                commit("setInAppNotifications", response.data.notifications);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async printNotification({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printNotification(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveNotification({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["notification_id"] === "undefined" || body["notification_id"] == null || body["notification_id"] == "") {
                delete body["notification_id"];
                response = await createNotifications({ body: body, headers: config.headers });
            } else {
                if (typeof body["read_flag"] !== "undefined" && body["read_flag"] != null && body["read_flag"] != "") {
                    let notification_id = body["notification_id"];
                    delete body["notification_id"];
                    response = await readOrUnreadNotifications(
                        { body: body, headers: config.headers },
                        notification_id,
                        body["read_flag"] == "1" ? "read" : "unread"
                    );
                } else {
                    let notification_id = body["notification_id"];
                    delete body["notification_id"];
                    response = await updateNotifications({ body: body, headers: config.headers }, notification_id);
                }
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log(error);
            console.log("save error");
            return;
        }
    },
    async deleteNotification({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteNotifications(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
    async createEmail({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let endpoint = payload.endpoint;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };
            response = await sendEmail({ body: body, headers: config.headers }, endpoint);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("email response error");
                return;
            }
        } catch (error) {
            console.log("email error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageNotifications(state, page) {
        state.notifications_page = page;
    },
    setNotifications(state, notifications) {
        state.notifications = notifications;
    },
    setInAppNotifications(state, notifications) {
        state.inAppNotifications = notifications;
    },
    setSelectedNotification(state, notification) {
        state.selectedNotification = notification;
    },
    resetSelectedNotification(state) {
        for (const key in state.selectedNotification) {
            if (key in state.rules_notifications) {
                state.selectedNotification[key] = state.rules_notifications[key].default_value == "null" ? null : state.rules_notifications[key].default_value;
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
